setNewRelicRoute